import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box, Chip, Alert, Divider, Paper, } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutlineOutlined";
import DescriptionIcon from "@mui/icons-material/Description";
import { useTranslation } from "react-i18next";
const ContractAffectedConfirmationDialog = ({ open, onClose, onConfirm, affectedContracts, loading = false }) => {
    const { t: translate } = useTranslation();
    const totalAffectedObjects = affectedContracts.reduce((sum, contract) => sum + contract.affectedObjectIds.length, 0);
    return (_jsxs(Dialog, { open: open, onClose: !loading ? onClose : undefined, maxWidth: "md", fullWidth: true, "aria-labelledby": "contract-affected-dialog-title", sx: {
            p: { xs: "4px 4px", md: "auto" },
            "& .MuiDialog-paper": {
                borderRadius: "8px",
            }
        }, children: [_jsx(DialogTitle, { id: "contract-affected-dialog-title", children: _jsxs(Box, { sx: {
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5
                    }, children: [_jsx(WarningAmberIcon, { sx: { fontSize: 32, color: "var(--n-primary, #130922)" } }), _jsx(Box, { sx: {
                                flex: 1
                            }, children: _jsx(Typography, { variant: "h6", sx: {
                                    color: "var(--n-primary, #130922)",
                                    fontWeight: 600,
                                    fontSize: "18px",
                                    lineHeight: "150%",
                                    letterSpacing: "0.5px",
                                }, children: translate("Contract Affected Warning") }) })] }) }), _jsxs(DialogContent, { sx: { paddingBottom: 0 }, children: [_jsxs(Alert, { severity: "warning", icon: _jsx(ErrorOutlineIcon, { fontSize: "medium" }), sx: {
                            mb: 2.5,
                            borderRadius: "8px",
                            "& .MuiAlert-message": {
                                width: "100%"
                            }
                        }, children: [_jsx(Typography, { variant: "body1", sx: {
                                    fontWeight: 600,
                                    fontSize: "15px",
                                    lineHeight: "150%",
                                    letterSpacing: "0.5px",
                                    mb: 1
                                }, children: translate("Status Change Impact Summary") }), _jsx(Typography, { variant: "body2", sx: {
                                    fontSize: "14px",
                                    lineHeight: "150%",
                                    color: "var(--Neutral-700, #495057)",
                                    mb: 1.5
                                }, children: translate("Changing the status of these objects will affect the following contracts:") }), _jsxs(Box, { sx: {
                                    display: "flex",
                                    gap: 1.5,
                                    flexWrap: "wrap"
                                }, children: [_jsx(Chip, { label: `${affectedContracts.length} ${translate("Contract(s)")}`, size: "small", sx: {
                                            height: "28px",
                                            fontWeight: 600,
                                            fontSize: "13px",
                                            backgroundColor: "var(--n-primary-light, #f9f6ff)",
                                            color: "var(--n-primary, #130922)",
                                            border: "1px solid var(--n-primary, #130922)",
                                            borderRadius: "8px",
                                        } }), _jsx(Chip, { label: `${totalAffectedObjects} ${translate("Object(s)")}`, size: "small", sx: {
                                            height: "28px",
                                            fontWeight: 600,
                                            fontSize: "13px",
                                            backgroundColor: "#fff",
                                            color: "var(--Neutral-700, #495057)",
                                            border: "1px solid var(--Neutral-700, #495057)",
                                            borderRadius: "8px",
                                        } })] })] }), _jsxs(Typography, { variant: "subtitle1", sx: {
                            mb: 2,
                            color: "var(--n-primary, #130922)",
                            fontWeight: 600,
                            fontSize: "15px",
                            lineHeight: "150%",
                            letterSpacing: "0.5px",
                        }, children: [translate("Affected Contracts Details"), ":"] }), _jsx(Box, { sx: { display: "flex", flexDirection: "column", gap: 2 }, children: affectedContracts.map((contract) => (_jsxs(Paper, { elevation: 0, sx: {
                                p: 2,
                                border: "1px solid",
                                borderColor: "#CED4DA",
                                borderRadius: "8px",
                                backgroundColor: "#fff",
                            }, children: [_jsxs(Box, { sx: {
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1.5,
                                        mb: 1.5
                                    }, children: [_jsx(Box, { sx: {
                                                width: 36,
                                                height: 36,
                                                borderRadius: "8px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                bgcolor: "var(--n-primary-light, #f9f6ff)",
                                                border: "1px solid var(--n-primary, #130922)",
                                            }, children: _jsx(DescriptionIcon, { sx: { color: "var(--n-primary, #130922)", fontSize: 20 } }) }), _jsxs(Box, { sx: {
                                                flex: 1
                                            }, children: [_jsx(Typography, { variant: "caption", sx: {
                                                        color: "var(--Neutral-700, #495057)",
                                                        fontSize: "11px",
                                                        textTransform: "uppercase",
                                                        letterSpacing: "0.5px",
                                                        lineHeight: "150%",
                                                    }, children: translate("Contract Number") }), _jsx(Typography, { variant: "h6", sx: {
                                                        color: "var(--n-primary, #130922)",
                                                        fontWeight: 600,
                                                        fontSize: "16px",
                                                        lineHeight: "150%",
                                                        letterSpacing: "0.5px",
                                                    }, children: contract.contractNumber })] }), _jsx(Chip, { label: translate("Will be removed"), size: "small", sx: {
                                                height: "26px",
                                                fontWeight: 600,
                                                fontSize: "12px",
                                                backgroundColor: "#F0A900",
                                                color: "#fff",
                                                borderRadius: "8px",
                                            } })] }), _jsx(Divider, { sx: { my: 1.5 } }), _jsxs(Box, { children: [_jsxs(Typography, { variant: "body2", sx: {
                                                mb: 1.5,
                                                color: "var(--Neutral-700, #495057)",
                                                fontWeight: 600,
                                                fontSize: "14px",
                                                lineHeight: "150%",
                                                letterSpacing: "0.5px",
                                            }, children: [translate("Affected Object IDs"), " (", contract.affectedObjectIds.length, "):"] }), _jsx(Box, { sx: {
                                                display: "flex",
                                                flexWrap: "wrap",
                                                gap: 1,
                                                p: 1.5,
                                                bgcolor: "var(--n-primary-light, #f9f6ff)",
                                                borderRadius: "8px",
                                                border: "1px dashed var(--n-primary, #130922)",
                                            }, children: contract.affectedObjectIds.map((objectId) => (_jsx(Chip, { label: objectId, size: "small", variant: "outlined", sx: {
                                                    height: "26px",
                                                    fontWeight: 500,
                                                    fontSize: "13px",
                                                    borderColor: "var(--n-primary, #130922)",
                                                    color: "var(--n-primary, #130922)",
                                                    borderRadius: "8px",
                                                } }, objectId))) })] })] }, contract.contractId))) })] }), _jsx(DialogActions, { children: _jsxs(Box, { sx: {
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        gap: 2,
                        width: "100%",
                        justifyContent: "flex-end",
                    }, children: [_jsx(Button, { variant: "outlined", color: "primary", onClick: onClose, disabled: loading, sx: {
                                display: "flex",
                                padding: "var(--1, 8px) var(--2, 16px)",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "var(--1, 8px)",
                                borderRadius: "var(--1, 8px)",
                                border: "var(--none, 1px) solid var(--n-primary, #130922)",
                            }, children: _jsx(Typography, { sx: {
                                    color: "var(--n-primary, #130922)",
                                    fontFeatureSettings: "'clig' off, 'liga' off",
                                    fontSize: "16px",
                                    fontStyle: "normal",
                                    fontWeight: 400,
                                    lineHeight: "150%",
                                    letterSpacing: "1px",
                                }, children: translate("Cancel") }) }), _jsx(Button, { variant: "contained", color: "primary", onClick: onConfirm, disabled: loading, autoFocus: true, sx: {
                                display: "flex",
                                padding: "var(--1, 8px) var(--2, 16px)",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "var(--1, 8px)",
                                borderRadius: "var(--1, 8px)",
                                border: "var(--n-primary, #130922)",
                            }, children: _jsx(Typography, { sx: {
                                    color: "var(--Neutral-White, #FFF)",
                                    fontFeatureSettings: "'clig' off, 'liga' off",
                                    fontSize: "16px",
                                    fontStyle: "normal",
                                    fontWeight: 400,
                                    lineHeight: "150%",
                                    letterSpacing: "1px",
                                }, children: loading ? translate("Processing...") : translate("Confirm & Continue") }) })] }) })] }));
};
export default ContractAffectedConfirmationDialog;
